<template>
  <div class="toggle-button form-control" @click.prevent="toggle">
    <div class="toggle-block" :class="{ 'primary-background-color': toggleStatusClass }">{{labelTrue}}</div>
    <div class="toggle-block" :class="{ 'primary-background-color': !toggleStatusClass }">{{labelFalse}}</div>
  </div>
</template>

<script>

export default {
  name: 'toggle',
  props: {
    value: Boolean,
    labelTrue: {
      type: String,
      default: 'True',
    },
    labelFalse: {
      type: String,
      default: 'False',
    },
  },
  data: () => ({
    toggleStatus: true,
  }),
  created() {
    this.toggleStatus = this.value === true;
  },
  computed: {
    toggleStatusClass() {
      return this.toggleStatus === true;
    },
  },
  methods: {
    toggle() {
      this.toggleStatus = !this.toggleStatus;
      this.$emit('input', this.toggleStatus);
    },
  },
  watch: {
    value(value) {
      this.toggleStatus = value;
    },
  },
};
</script>

<style lang="scss">
.toggle-button {
  width: 100%;
  height: calc(2.25rem + 2px);
  border-radius: .15rem;
  display: flex;
  flex-direction: row;

  &.form-control {
    margin-top: -2px;
    padding: 0;
  }

  .toggle-block {
    padding-top: 2px;
    line-height: calc(2rem);
    border-radius: .15rem;
    font-size: 0.8em;
    font-weight: normal;
    text-align: center;
    vertical-align: center;
    cursor: pointer;
    flex: 1;
  }

  .primary-background-color {
    color: white;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/misc/toggle.vue